import React from 'react';
import { INPUT_GLOBAL_TYPES } from '../../constants/constants';

export enum INPUT_TYPE {
  SEARCH = 'search',
  PASSWORD = 'password',
  REGULAR = 'regular',
}

export interface ERR_SPAN {
  errStatus: boolean;
  errText?: string;
}

export interface InputIterface {
  ver: INPUT_TYPE;
  onSearch?: () => void;
  errStatus: boolean;
  errMessage?: string;
  placeholder: string;
  customWidth?: number;
  customMargin?: number;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  name?: string;
  accept?: INPUT_GLOBAL_TYPES;
  inputValue?: string | number;
}
